module.exports = __webpack_public_path__ + "static/gallery16-cfe6b02e1b6cd9df5b00e6150dec8725.jpg";